'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var routes = [
// 会员信息
{
  path: '/user',
  component: function component() {
    return import('@views/user/index.vue');
  },
  name: 'vip-user',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '个人中心'
  }
}, {
  path: '/user/detail',
  component: function component() {
    return import('@views/user/base.vue');
  },
  name: 'vip-user-detail',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '基本信息'
  }
},
// 完善用户信息
{
  path: '/register/form/:id',
  component: function component() {
    return import('@views/entry/register/form.vue');
  },
  name: 'register-form',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '完善用户信息'
  }
},
// 填写报名信息
{
  path: '/update/form',
  component: function component() {
    return import('@views/entry/register/form.vue');
  },
  name: 'update-user-info',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '修改用户信息'
  }
},
// 恢复密码
{
  path: '/reset',
  component: function component() {
    return import('@views/entry/recovery.vue');
  },
  name: 'reset-pwd',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '更新密码'
  }
},
// 订单列表
{
  path: '/order/list/:id',
  component: function component() {
    return import('@views/user/order-list.vue');
  },
  name: 'order-list',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '我的订单'
  }
},
// 票据列表
{
  path: '/invoice/list',
  component: function component() {
    return import('@views/user/invoice-list.vue');
  },
  name: 'invoice-list',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '我的票据'
  }
},
// 我的证书
{
  path: '/certificate',
  component: function component() {
    return import('@views/user/certificate.vue');
  },
  name: 'certificate',
  meta: {
    auth: ['authc'],
    group: 'user',
    title: '我的证书'
  }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ./src/router/user.js
// module id = 590
// module chunks = 14